<template>
    <div>
        <validation-observer v-slot="{ invalid, handleSubmit }" ref="feedbackValidator" v-if="features.canEdit()">
            <form @submit.prevent="handleSubmit(submit)" @keydown="errors.clear($event.target.name)">

                <drawing class="mb-3" ref="drawingZone"
                    v-model="file"
                    :url="endpoint"
                    :form-data="formData"
                    @erased="erased"
                    @drawn="drawn"
                    @complete="complete"
                    @errors="error"
                    @success="success"
                ></drawing>

                <div class="text-warning mb-3" style="margin-top:-10px" v-if="errorFound">
                    <small>{{ $t('feedbacks.file-upload-error') }}</small>
                </div>

                <div class="text-center">
                    <base-button native-type="submit"
                        type="primary"
                        :disabled="errors.any() || invalid || !readyToUpload"
                        :loading="uploading"
                    >
                        {{ $t('common.save') }}
                    </base-button>

                    <base-button type="link" class="ml-auto" @click="modal.show = false">
                        {{ $t('common.cancel') }}
                    </base-button>
                </div>

            </form>
        </validation-observer>

         <div class="pb-3" v-else>
            <div v-if="value.file_src && value.file_src.trim().length > 0">
                <img :src="value.file_src" />
            </div>
            <div v-else>
                {{ $t('dashboard.no-picture') }}
            </div>
         </div>
    </div>
</template>

<script>
    export default {
        
        props: {

            value: {
                type: Object,
                required: true
            },

            errors: {
                type: Object,
                required: true
            },

            modal: {
                type: Object,
                required: true
            },

            features: {
                default: null
            },

            endpoint: {
                type: String,
                required: true
            },
        },

        data() {
            return {
                file: null,
                drawzone: null,
                readyToUpload: false,
                uploading: false,
                errorFound: false,
                restored: false,
            }
        },

        created() {
            this.errors.setValidator('feedbackValidator', this)
        },

        computed: {

            formData() {
                return {...this.value}
            }
        },

        watch: {

            modal(val) {
                if (val.show) {
                    this.init()
                }
            },

            value(val) {
                if (val.file_src) {
                    this.restore()
                }
            }
        },

        methods: {

            init() {
                this.file = null
                this.restored = false
                this.uploading = false
                this.readyToUpload = false
                this.errorFound = false
                this.drawzone = this.$refs.drawingZone
                this.drawzone.reset()
            },

            restore() {
                this.restored = true
                this.drawzone.restore(this.value.file_src)
            },

            drawn(event) {
                this.errorFound = false
                this.readyToUpload = true
            },

            erased(event) {
                this.file = null
                this.readyToUpload = this.restored
                this.errorFound = false
            },

            submit() {
                this.errorFound = false
                this.uploading = true
                this.drawzone.post()
            },

            complete(event) {
                this.uploading = false
            },

            error(errors) {
                this.errors.set(errors)
                if (errors.file) {
                    this.errorFound = true
                    this.readyToUpload = false
                }
            },
            
            success(event) {
                this.modal.show = false
                this.$emit('change', { ...this.value})
            },
        }
    }
</script>
